import { render } from "./VtoHotswapLooks.vue?vue&type=template&id=19f50d82"
import script from "./VtoHotswapLooks.vue?vue&type=script&lang=js"
export * from "./VtoHotswapLooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__